import { render } from "./genderInput.vue?vue&type=template&id=85166216"
import script from "./genderInput.vue?vue&type=script&lang=js"
export * from "./genderInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__